module.exports = __webpack_public_path__ + "static/media/csszen.d07e05db.JPG";